import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
    size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

const sizeClasses = {
    sm: 'max-w-2xl',
    md: 'max-w-4xl',
    lg: 'max-w-6xl',
    xl: 'max-w-7xl',
    full: 'max-w-full',
};

/**
 * Container — Central page width constraint with responsive margins.
 * Wraps page content to enforce max-width and horizontal padding.
 */
export const Container = forwardRef<HTMLDivElement, ContainerProps>(
    ({ size = 'xl', className, children, ...rest }, ref) => {
        return (
            <div
                ref={ref}
                className={cn('w-full mx-auto px-4 tablet:px-6', sizeClasses[size], className)}
                {...rest}
            >
                {children}
            </div>
        );
    }
);

Container.displayName = 'Container';
